import { ReduxStore } from 'store/types';

function getAllIsLoading(state: ReduxStore): boolean {
  return state.category.getAll.config.isLoading;
}

export default getAllIsLoading;
